import { render, staticRenderFns } from "./VolumeControllerParts.vue?vue&type=template&id=8ad1853a&scoped=true"
import script from "./VolumeControllerParts.vue?vue&type=script&lang=ts"
export * from "./VolumeControllerParts.vue?vue&type=script&lang=ts"
import style0 from "./VolumeControllerParts.vue?vue&type=style&index=0&id=8ad1853a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad1853a",
  null
  
)

export default component.exports